const childRoutes = (prop) => [
  {
    path: 'raw-material-requisition-list',
    name: prop + '.raw_material_requisition_list',
    meta: { auth: true },
    component: () => import('../pages/raw-material-requisition/List.vue')
  },
  {
    path: 'raw-material-requisition-entry',
    name: prop + '.raw_material_requisition_entry',
    meta: { auth: true },
    component: () => import('../pages/raw-material-requisition/Form.vue')
  },
  {
    path: 'raw-material-requisition-request-list',
    name: prop + '.raw_material_requisition_request_list',
    meta: { auth: true },
    component: () => import('../pages/raw-material-requisition-request/List.vue')
  },
  {
    path: 'raw-material-requisition-approve-list',
    name: prop + '.raw_material_requisition_approve_list',
    meta: { auth: true },
    component: () => import('../pages/raw-material-requisition-approve-list/List.vue')
  },
  {
    path: 'raw-material-disburse-list',
    name: prop + '.raw_material_disburse_list',
    meta: { auth: true },
    component: () => import('../pages/raw-material-disburse/List.vue')
  },
  {
    path: 'raw-material-disbursement-list',
    name: prop + '.raw_material_disbursement_list',
    meta: { auth: true },
    component: () => import('../pages/raw-material-disbursement-list/List.vue')
  },
  {
    path: 'raw-material-stock-manage',
    name: prop + '.raw_material_stock_manage',
    meta: { auth: true },
    component: () => import('../pages/raw-material-stock-manage/List.vue')
  },
  {
    path: 'raw-material-stock-manage-entry',
    name: prop + '.raw_material_stock_manage-entry',
    meta: { auth: true },
    component: () => import('../pages/raw-material-stock-manage/Form.vue')
  },
  {
    path: 'raw-material-purchase-manage',
    name: prop + '.raw_material_purchase_manage',
    meta: { auth: true },
    component: () => import('../pages/raw-material-purchase-manage/List.vue')
  },
  {
    path: 'raw-material-purchase-entry',
    name: prop + '.raw_material_purchase_entry',
    meta: { auth: true },
    component: () => import('../pages/raw-material-purchase-manage/Form.vue')
  },
  {
    path: 'production-target-manage',
    name: prop + '.production_target_manage',
    meta: { auth: true },
    component: () => import('../pages/production-target-manage/List.vue')
  },
  {
    path: 'production-target-manage-entry',
    name: prop + '.production_target_manage-entry',
    meta: { auth: true },
    component: () => import('../pages/production-target-manage/Form.vue')
  },
  {
    path: 'production-target-request',
    name: prop + '.production_target_request',
    meta: { auth: true },
    component: () => import('../pages/production-target-request/List.vue')
  },
  {
    path: 'production-target-approve-list',
    name: prop + '.production_target_approve_list',
    meta: { auth: true },
    component: () => import('../pages/production-target-approve-list/List.vue')
  },
  {
    path: 'receive-against-purchase-order',
    name: prop + 'receive_against_purchase_order',
    meta: { auth: true },
    component: () => import('../pages/receive-against-purchase-order/List.vue')
  },
  {
    path: 'receive-against-purchase-order-entry',
    name: prop + 'receive_against_purchase_order_entry',
    meta: { auth: true },
    component: () => import('../pages/receive-against-purchase-order/Form.vue')
  },
  {
    path: 'raw-material-purchase-receive-list',
    name: prop + 'raw_material_purchase_receive_list',
    meta: { auth: true },
    component: () => import('../pages/raw-material-purchase-receive-list/List.vue')
  },
  {
    path: 'production-stock-manage',
    name: prop + 'production_stock_manage',
    meta: { auth: true },
    component: () => import('../pages/production-stock-manage/List.vue')
  },
  {
    path: 'production-stock-manage-entry',
    name: prop + '.production-stock-manage-entry',
    meta: { auth: true },
    component: () => import('../pages/production-stock-manage/Form.vue')
  },
  {
    path: 'stock-report',
    name: prop + '.stock-report',
    meta: { auth: true },
    component: () => import('../pages/stock-report/List.vue')
  },
  {
    path: 'target-against-production-report-with-stock',
    name: prop + 'target_against_production_report_with_stock',
    meta: { auth: true },
    component: () => import('../pages/target-against-production-report-wstock/List.vue')
  },
  // {
  //   path: 'production-sales-stock-reports-water',
  //   name: prop + 'production_sales_stock_reports_water',
  //   meta: { auth: true },
  //   component: () => import('../pages/production-sales-stock-reports-water/List.vue')
  // },
  {
    path: 'raw-material-stock-report',
    name: prop + 'raw_material_stock_report',
    meta: { auth: true },
    component: () => import('../pages/raw-material-stock-report/List.vue')
  },
  {
    path: 'mukta-water-production-sales-stock-report',
    name: prop + 'mukta_water_production_sales_stock_report',
    meta: { auth: true },
    component: () => import('../pages/mukta-water-production-sales-stock-report/List.vue')
  },
  {
    path: 'product-dashboard',
    name: prop + 'product_dashboard',
    meta: { auth: true },
    component: () => import('../pages/product-dashboard/Dashboard.vue')
  }
]
const routes = [{
  path: '/production-service/store-management',
  name: 'production_service.store-management',
  component: () => import('@/layouts/ProductionLayout.vue'),
  meta: { auth: true },
  children: childRoutes('production_service.store-management')
}]

export default routes
